import React from 'react'
import { Outlet, NavLink, useParams, useNavigate, useLocation } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { ConfigProvider } from '../../contexts/ConfigContext'
import { listConfigs } from '../../api/graphConfigs'
import { PageSection } from '../../components/ui'
import '../../styles/pages/settings.css'
import '../../styles/pages/page-common.css'

/** Layout для редактирования конкретной конфигурации. Подменю: Переменные, Агенты, Связи, Узлы, Проактивный бот. */
export default function SettingsConfigDetailLayout() {
  const { t } = useI18n()
  const { configId } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [config, setConfig] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    if (!configId) return
    listConfigs()
      .then((list) => {
        const arr = Array.isArray(list) ? list : list?.data ?? []
        const c = arr.find((x) => String(x.id) === configId)
        setConfig(c)
      })
      .catch(() => setConfig(null))
      .finally(() => setLoading(false))
  }, [configId])

  const configListPath = pathname.startsWith('/v2') ? '/v2/configuration' : '/old/settings/configuration'
  const base = `${configListPath}/${configId}`

  if (loading) {
    return <p className="settings-loading">{t('common.loading')}</p>
  }

  if (!config) {
    return (
      <div className="settings-section">
        <p className="settings-error">{t('settings.config.notFound') || 'Конфигурация не найдена'}</p>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(configListPath)}>
          ← {t('settings.config.backToList') || 'К списку'}
        </button>
      </div>
    )
  }

  return (
    <ConfigProvider configId={configId ? Number(configId) : null}>
      <PageSection
        className="settings-config-detail"
        title={config.name}
        badge={config.is_active ? (t('settings.config.active') || 'Активный') : null}
        backHref={configListPath}
        backLabel={t('modelDetail.backToList') || '← К списку'}
        compact
      >
        <nav className="settings-config-tabs">
          <NavLink to={`${base}/graph`} className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}>
            {t('settings.nav.graph')}
          </NavLink>
          <NavLink to={`${base}/agents`} className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}>
            {t('settings.nav.agents')}
          </NavLink>
          <NavLink to={`${base}/nodes`} className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}>
            {t('settings.nav.nodes')}
          </NavLink>
          <NavLink to={`${base}/proactive`} className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}>
            {t('settings.nav.proactive')}
          </NavLink>
          <NavLink to={`${base}/settings`} className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}>
            {t('settings.nav.executor')}
          </NavLink>
        </nav>
        <div className="settings-config-detail-content settings-config-blocks">
          <Outlet />
        </div>
      </PageSection>
    </ConfigProvider>
  )
}
